module.exports = __webpack_public_path__ + "img/wallet-home2.9fd4595b.png";